import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmGsConfigProviderEntrypointProps } from './JsmGsConfigProvider.entrypoint.types.tsx';

type QueuesSettingsConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JsmGsConfigProviderEntrypointProps,
	{} | null
>;

export const queuesSettingsConfigProviderEntrypoint: EntryPoint<
	QueuesSettingsConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<QueuesSettingsConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-jsm-gs-queues-settings-provider" */ './QueuesSettingsConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
